import { jsx as _jsx } from "react/jsx-runtime";
import { Grid } from "@mui/material";
import { GRID_COLUMNS } from "./types";
import { gridItemSize } from "./lib/layout";
import { MonitoringWidgetCard } from "./MonitoringWidgetCard";
/** The layout on a 12-column grid; every widget takes the full row on small screens. */
export function MonitoringWidgetGrid(_a) {
    var cells = _a.cells, context = _a.context;
    return (_jsx(Grid, { container: true, spacing: 2, columns: GRID_COLUMNS, children: cells.map(function (cell) { return (_jsx(Grid, { size: gridItemSize(cell.width), children: _jsx(MonitoringWidgetCard, { cell: cell, context: context }) }, cell.key)); }) }));
}
